/* eslint-disable no-unused-vars */
/* eslint-disable no-alert */
/* OPTIONAL insurance module, if not provided, insurance buttons won't be visible */
export default {
  isEnabled: function (_isEnabled = false) {
    return _isEnabled
  },

  isLoading: function (_isLoading = false) {
    return _isLoading
  },

  isLogged: function (_isLogged = false) {
    return _isLogged
  },

  getEvents: function () {
    return {
      INSURANCE_LOGIN: 'insuranceLogin',
      INSURANCE_LOGIN_LOADING: 'isLoginLoading',
      INSURANCE_LOGIN_ERROR: 'insuranceLoginError',
      INSURANCE_LOGOUT: 'insuranceLogout',
      INSURANCE_ENABLED: 'insuranceEnabled',
      INSURANCE_DISABLED: 'insuranceDisabled',
      INSURANCE_TENTATIVE_UPDATE: 'insuranceTentativeUpdate',
      INSURANCE_TENTATIVE_LIMIT_REACHED: 'insuranceTentativeLimitReached',
      INSURANCE_TENTATIVE_RESET: 'insuranceTentativeReset',
      INSURANCE_DISCOUNT_LOADING: 'isDiscountLoading',
      INSURANCE_DISCOUNT_ERROR: 'insuranceDiscountError',
      INSURANCE_DISCOUNT_LOADED: 'insuranceDiscountLoaded',
      INSURANCE_NOT_FOUND: 'insuranceNotFound',
    }
  },
}
